module.exports = __webpack_public_path__ + "static/media/gallery-17.604081cc.jpeg";